import {gql} from 'apollo-angular';
export const GET_SCHOOL_CLASS_RANKINGS = gql`
  query GetSchoolClassRankings {
    schoolClassRankings {
      school {
        name
      }
      schoolClass {
        id
        name
        classNumber
        classAddition
        school {
          name
        }
      }
      points
      playtimeMinutes
    }

  }
`;
